import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApplicationRoutingModule } from './application-routing.module';
import { ApplicationComponent } from './application.component';
import { MaterialModule } from '../../shared/material.module';
import { SharedModule } from '../../shared/shared.module';
import { PrimengModule } from '../../shared/primeng-module';
import { HeaderComponent } from './page-application/header/header.component';
import { SidemenuComponent } from './page-application/sidemenu/sidemenu.component';
import { FooterComponent } from './page-application/footer/footer.component';
import { AddressSearchComponent } from './page-application/header/address-search/address-search.component';
import { NotificationsComponent } from './page-application/header/notifications/notifications.component';
import { UserComponent } from './page-application/header/user/user.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageApplicationModule } from './page-application/page-application.module';
import { CustomReuseStrategy } from '../../shared/custom-reuse-strategy';
import { RouteReuseStrategy } from '@angular/router';
import { AdminModule } from '../admin/admin.module';


@NgModule({
  imports: [
    CommonModule,
    ApplicationRoutingModule,
    MaterialModule,
    PrimengModule,
    SharedModule,
    PageApplicationModule.forRoot(),
    AdminModule
  ],
  declarations: [
    ApplicationComponent
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
  ],
  bootstrap: [ApplicationComponent]
})
export class ApplicationModule { }
